exat_startAttribute ();

function exat_startAttribute () {

    if(exat_page=='cart'){
    pifyJquery (document).ready (function () {
      //adjust price event
      if(pifyJquery(".exat-adjust-price").length>0){
        var checkoutSelectors = "input[name='checkout'], input[value='Checkout'], button[name='checkout'], [href$='checkout'], button[value='Checkout'],button[type='submit']";
        var cartUpdated=false;
        $(document).on('click', checkoutSelectors, function(e){
          pifyJquery.ajaxSettings.async = false;
          var $checkout=pifyJquery(this);
          if(!cartUpdated){
            if(pifyJquery(".exat-attribute").parents("form").valid()){
              e.preventDefault();
            
                var selectedVariantIds=[];
                  pifyJquery('.exat-attribute select').each(function(i,item){
                      var $selected=pifyJquery(item).find('option:selected');
                      if($selected!=undefined){
                          if($selected.val()!=''&&$selected.attr('is-adjust-price')=='true'){
                          var variantId=$selected.attr('variant-id');
                          selectedVariantIds.push(variantId);

                        }
                      }
                  });//select each
                  pifyJquery(".exat-attribute .adjust-price-radio").each(function(i,item){
                    if(pifyJquery(this).is(":checked")){
                      var variantId=pifyJquery(this).attr('variant-id');
                      selectedVariantIds.push(variantId);
                    }
                  });//radio each
                  pifyJquery(".exat-attribute .adjust-price-checkbox").each(function(i,item){
                    if(pifyJquery(this).is(":checked")){
                      var variantId=pifyJquery(this).attr('variant-id');
                      selectedVariantIds.push(variantId);
                    }
                  });//checkbox each
                  //clear cart for additional
                  var deleteVariantIds=[];
                  pifyJquery.get("/cart.js", function(cart){
                      pifyJquery(cart.items).each(function(i,item){
                        if(item.vendor=="Pifyapp"){
                          deleteVariantIds.push(item.variant_id);
                        }
                      });

                  },'json');
                  if(selectedVariantIds.length>0){
                    var deletes="";
                    pifyJquery(deleteVariantIds).each(function(i,item){
                        deletes=deletes+"updates["+item+"]=0&"
                    });//delete variants each
                    if(deletes.length>0){
                        deletes=deletes.substr(0,deletes.length-1);
                    }
                    pifyJquery.post('/cart/update.js', deletes);
                    //update cart
                    var updates="";
                    pifyJquery(selectedVariantIds).each(function(i,item){
                        updates=updates+"updates["+item+"]=1&"
                    });//update variants each
                    if(updates.length>0){
                        updates=updates.substr(0,updates.length-1);
                    }
                    pifyJquery.post('/cart/update.js', updates, function(data){
                        cartUpdated=true;
                        $checkout.click();
                    });
                  }
                  else{
                    cartUpdated=true;
                    $checkout.click();
                  }
              }
            }
        });//checkout click
      }
    });//ready
  }

  if(exat_page=='cart' || exat_page=='register'){
        pifyJquery (document).ready (function () {
          pifyJquery(".exat-attribute").parents("form").validate({ignore: ":not(.exat-attribute select, .exat-attribute input,.exat-attribute textarea)"});
          pifyJquery("#RegisterForm").validate();
          
          pifyJquery ('.exat-datepicker').datepicker ({
            dateFormat: 'yy/mm/dd',
            changeMonth: true,
            changeYear: true,
            yearRange: 'c-70:c+10',
          });
          
          if(pifyJquery('.exat-attribute').length>0){
            pifyJquery.ajax ({
              url: 'https://customized-attribute.pifyapp.com/api/pricing/check_available?shop=' + pify_shop,
              dataType: 'json',
              success: function (data) {
                if(!(data.code==1 )){
                  pifyJquery('.exat-attribute').find("input").attr("disabled","disabled");
                  pifyJquery('.exat-attribute').find("textarea").attr("disabled","disabled");
                  pifyJquery('.exat-attribute').find("select").attr("disabled","disabled");
                  
                  pifyJquery('.exat-attribute').find("input").css("background-color","#dedede");
                  pifyJquery('.exat-attribute').find("textarea").css("background-color","#dedede");
                  pifyJquery('.exat-attribute').find("select").css("background-color","#dedede");
                }
              },
            });//ajax end
          }
        });
  }
  else if (exat_page == 'account') {
    pifyJquery (document).ready (function () {
      var $wrap = pifyJquery ('#exat_account_attribute_wrap');
      var shop = $wrap.attr ('shop');
      var customerId = $wrap.attr ('customer-id');
      var header = '<h4>Additional</h4>';
      var render = '<ul>{items}</ul>';

      // ajax get data
      pifyJquery.ajax ({
        url: 'https://customized-attribute.pifyapp.com/api/customer/note/list?shop=' +
          shop +
          '&customerId=' +
          customerId,
        dataType: 'json',
        success: function (data) {
          console.log (data);
          var items = '';
          var item = '<li>{itemContent}</li>';
          if (data != null && data.length > 0) {
            for (var index = 0; index < data.length; index++) {
              items =
                items +
                item.replace (
                  '{itemContent}',
                  data[index].key + ' : ' + data[index].value
                );
            }
            render = render.replace ('{items}', items);
            $wrap.html (header + '\n' + render);
          }
        },
      });
    });
  }

  
}


function exat_fun_checkbox(source,target){
  var targetValue="";
  var checkboxs=document.getElementsByName(source);
  for(var i=0;i<checkboxs.length;i++)
  {
    if(checkboxs[i].checked){
      targetValue=targetValue+checkboxs[i].value+',';
    }
  }
  if(targetValue.length>0){
    targetValue=targetValue.substr(0,targetValue.length-1);
  }

  document.getElementById(target).value=targetValue;
}
